export type TypeNameSize = "sm" | "md" | "lg";
